import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { SortPayload, UserSettingsResponse } from '../../../types/User';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

export const updateUserSorts = async (formData: SortPayload): Promise<UserSettingsResponse> => {
  const response = await CustomAxios.put(`user-sorts`, { settings: formData });
  const { data } = response;
  return data;
};

export function useUpdateUserSorts() {
  return useMutation({
    mutationFn: (formData: SortPayload) => updateUserSorts(formData),
    onSuccess: () => {
      // fetch the user sorts again after update
      queryClient.invalidateQueries({ queryKey: [queryKeys.currentUserSettings] });
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        const data: UserSettingsResponse = err.response.data as UserSettingsResponse;
        queryClient.setQueryData([queryKeys.currentUserSettings], data);
      }
    },
  });
}
